export const getCssRgbValue = (cssVar: string, opacity?: number) => {
  if (typeof document === 'undefined') return ''

  const root = document.documentElement

  if (opacity !== undefined)
    return `rgb(${getComputedStyle(root).getPropertyValue(cssVar).trim()} / ${opacity})`

  return `rgb(${getComputedStyle(root).getPropertyValue(cssVar).trim()})`
}
